// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel-control-prev-icon {
    position: absolute;
    left: 0;
    filter: invert(100%);
  }
  .carousel-control-next-icon {
    position: absolute;
    right: 0;
    filter: invert(100%);
  }

`, "",{"version":3,"sources":["webpack://./src/components/style.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,OAAO;IACP,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,oBAAoB;EACtB","sourcesContent":[".carousel-control-prev-icon {\n    position: absolute;\n    left: 0;\n    filter: invert(100%);\n  }\n  .carousel-control-next-icon {\n    position: absolute;\n    right: 0;\n    filter: invert(100%);\n  }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
